import { useSelector } from "react-redux";

export const FormRegion = props =>{
    const { className, icon, title, children, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);

    return (
        <div className={`form-region-container ${className}`}>
            <div className="form-region-root">    
                {
                    (icon || title) &&            
                    <div className="header">                    
                        {
                            icon && 
                            <div className={`icon k-icon k-i-${icon}`}></div>
                        }
                        {
                            title && 
                            <div className="title">{title}</div>
                        }
                        <div className="right-line"></div>
                    </div>
                }
                <div className="content">
                    {
                        children
                    }
                </div>
            </div>
            <style>
                {
                    `
                        .form-region-container
                        {
                        }

                        .form-region-root
                        {
                            display: flex;
                            flex-direction: column;
                            /*background-color: ${currentTheme.componentBg};*/
                        }

                        .form-region-root > .header
                        {
                            display: flex;
                            align-items: center;
                            /*margin-bottom: 8px;*/
                        }

                        .form-region-root > .header .k-icon
                        {
                            margin-right: 4px;
                        }

                        .form-region-root > .header .title
                        {
                            color: ${currentTheme.componentText};
                            font-style: italic;
                            font-weight: 500;
                        }

                        .form-region-root > .header .right-line
                        {
                            flex: 1;
                            height: 3px;
                            border-bottom: 1px solid ${currentTheme.componentBorderColor};
                            margin-left:6px;
                        }

                        .form-region-root > .content
                        {                            
                            display: flex;
                            flex-direction: column;
                            margin-top: 4px;
                        }                        
                    `
                }
            </style>
        </div>
    );
};